import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Phone, Mail } from "lucide-react";
import SEO from "../components/SEO";
import { BUSINESS, IMAGES, LOGO_FULL } from "../lib/site";

export default function AboutPage() {
  return (
    <>
      <SEO
        title="About PR7 MOT Centre | Local Garage in Adlington, Chorley, Lancashire"
        description="PR7 MOT Centre is a local, independent automotive business based at Margaret House, Huyton Road, Adlington, PR7 4HD. Professional MOTs, servicing and vehicle maintenance. Call 01257 786 540."
        path="/about-us"
      />

      <section className="relative bg-navy overflow-hidden">
        <div className="absolute inset-0 eng-grid" />
        <div className="container-pr7 relative py-16 lg:py-20">
          <p className="eyebrow-light mb-3">About Us</p>
          <h1 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tight">Local garage. Professional service.</h1>
          <p className="text-pale/70 text-base sm:text-lg leading-relaxed mt-5 max-w-2xl">
            PR7 MOT Centre is a local automotive business based in Adlington, Chorley, Lancashire - providing MOT testing, servicing, inspections and vehicle maintenance to drivers across the area.
          </p>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-pr7 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img src={IMAGES.workshop} alt="The PR7 MOT Centre workshop in Adlington" className="rounded-lg object-cover w-full h-80 lg:h-[440px] shadow-xl" loading="lazy" />
          </div>
          <div>
            <h2 className="font-heading font-extrabold text-ink text-2xl sm:text-3xl tracking-tight">Based in Adlington, working on modern vehicles every day</h2>
            <p className="text-muted-foreground leading-relaxed mt-4">
              From our workshop at Margaret House on Huyton Road, we look after everyday cars and light commercial vehicles for customers across Adlington, Chorley and the surrounding Lancashire area. Our work covers Class 4 MOT testing, interim and full servicing, wheel alignment, vehicle inspections and specialist Ford wet belt replacement.
            </p>
            <p className="text-muted-foreground leading-relaxed mt-4">
              We keep things straightforward: clear guide prices, honest advice and no work carried out without your agreement. If you would like to book in or ask a question, call us or send a booking request online.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link to="/booking" data-testid="about-book-btn" className="btn-primary">REQUEST BOOKING <ArrowRight size={16} /></Link>
              <Link to="/contact" data-testid="about-contact-btn" className="inline-flex items-center justify-center gap-2 border border-brand/40 text-brand hover:bg-pale font-heading font-bold tracking-wide px-6 py-3 rounded-md transition-colors">CONTACT US</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface py-14">
        <div className="container-pr7">
          <div className="bg-navy rounded-lg p-8 lg:p-10 relative overflow-hidden">
            <div className="absolute inset-0 eng-grid" />
            <div className="relative grid grid-cols-1 md:grid-cols-[auto_1fr] gap-10 items-center">
              <img src={LOGO_FULL} alt="PR7 MOT & Service Centre logo" className="w-48 sm:w-56 rounded-lg border border-deep shadow-xl" />
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div className="flex gap-3.5">
                <MapPin className="text-sky shrink-0" size={22} />
                <div>
                  <p className="font-heading font-bold text-white text-sm uppercase tracking-wider">Find Us</p>
                  <p className="text-pale/70 text-sm mt-2 leading-relaxed">Margaret House<br />Huyton Road<br />Adlington<br />PR7 4HD</p>
                </div>
              </div>
              <div className="flex gap-3.5">
                <Phone className="text-sky shrink-0" size={22} />
                <div>
                  <p className="font-heading font-bold text-white text-sm uppercase tracking-wider">Call Us</p>
                  <a href={BUSINESS.phoneHref} data-testid="about-phone" className="text-pale/70 hover:text-sky text-sm mt-2 block transition-colors">{BUSINESS.phone}</a>
                </div>
              </div>
              <div className="flex gap-3.5">
                <Mail className="text-sky shrink-0" size={22} />
                <div>
                  <p className="font-heading font-bold text-white text-sm uppercase tracking-wider">Email Us</p>
                  <a href={`mailto:${BUSINESS.email}`} data-testid="about-email" className="text-pale/70 hover:text-sky text-sm mt-2 block break-all transition-colors">{BUSINESS.email}</a>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
